//图片剪切弹窗
<template>
    <el-dialog
    title="剪裁图片"
    :visible.sync="cropperShow"
    width="600px"  
    center>
    <div class="cropper">
        <VueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :fixedBox="option.fixedBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :centerBox="option.centerBox"
            :high="option.high"
            :infoTrue="option.infoTrue"
            :enlarge="option.enlarge"
        ></VueCropper>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-tooltip class="item" effect="dark" content="图片放大" placement="top">
            <el-button icon="el-icon-zoom-in" size="small" @click="zoomIn"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="图片缩小" placement="top">
            <el-button icon="el-icon-zoom-out" size="small" @click="zoomOut"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="左旋转90°" placement="top">
            <el-button icon="el-icon-refresh-left" size="small" @click="leftRotate"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="右旋转90°" placement="top">
            <el-button icon="el-icon-refresh-right" size="small" @click="rightRotate"></el-button>
        </el-tooltip>
        <el-button icon="el-icon-upload" plain size="small" class="updataBox">
         重新上传
         <input
            class="file"
            name="image"
            type="file"
            :value="upload_input"
            accept="image/png,image/gif,image/jpeg"
            @change="Imgupdate($event)"
          />     
        </el-button>
        <el-button type="primary" @click="besureGetbase" size="small">确定剪裁</el-button>
    </span>
    </el-dialog>
</template>
<script>
import home from '@/api/home'
export default {
    name:'cropper',
    data(){
        return{
          option: {
            img: "",
            outputSize: 1, //剪切后的图片质量（0.1-1）
            full: false, //输出原图比例截图 props名full
            outputType: "png", //裁剪生成图片的格式
            canMove: true, //上传图片是否可以移动
            original: false, //上传图片按照原始比例渲染
            canMoveBox: false, //截图框是否可以拖动
            autoCrop: true, //是否默认生成截图框
            autoCropWidth: 400, //默认截图框宽度
            autoCropHeight: 300, //默认生成截图框高度
            fixedBox: false, //固定截图框大小
            fixedNumber: [1, 1], //截图框的宽高比例
            mode: "auto 200px", //图片默认渲染方式
            info: true, //裁剪框的大小信息
            canScale: true, //图片是否允许滚轮缩放
            fixed: true, //是否开启截图框宽高固定比例
            centerBox: true, //截图框是否被限制在图片里面
            high: true, //是否按照设备的dpr 输出等比例图片
          },
          uploadType:'',
          cropperShow:false,
          upload_input:'',
        }
    },
    methods:{
        Imgupdate(e,type){
            var selft = this;
            //上传图片
            var file = e.target.files[0];
            selft.fileName = file.name;
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
                return false;
            }
            var reader = new FileReader();
            reader.onload = (e) => {
                let data;
                if (typeof e.target.result === "object") {
                // 把Array Buffer转化为blob 如果是base64不需要
                data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                data = e.target.result;
                }
                selft.option.img = data;
            };
            // 转化为base64
            if(type){
                this.uploadType = type
            }
            reader.readAsDataURL(file);
            e.target.value = '';
        },
        zoomIn(){
            this.$refs.cropper.changeScale(1)
        },
        zoomOut(){
            this.$refs.cropper.changeScale(-1)
        },
        leftRotate(){
            this.$refs.cropper.rotateLeft()
        },
        rightRotate(){
            this.$refs.cropper.rotateRight()
        },
        besureGetbase(){
            this.$refs.cropper.getCropData(data => {
                var imgbase64 = data.replace(/^data:image\/\w+;base64,/, "");//去掉base64位头部
                home.analysisImageAddress(this,imgbase64).then(res=>{
                    if(res.success){
                        const result = res.data[0]
                        console.log(result)
                        this.$parent.ruleForm[this.uploadType] = {
                            name: result.name,
                            phone: result.phone,
                            province: result.province_name,
                            province_code: result.province_code,
                            city: result.city_name,
                            city_code: result.city_code,
                            area: result.district_name,
                            area_code: result.district_code,
                            address: result.address,
                            pca: [result.province_code, result.city_code, result.district_code], // 省市区
                        }
                        this.cropperShow = false;
                    }else{
                        this.cropperShow = false
                    }
                })

            })  
        }
    }
}
</script>
<style lang="stylus" scoped>
.cropper{
    height: 300px;
}
.updataBox{
    position relative
    .file{
        position: absolute
        z-index 99
        opacity 0
        left: 0
        top:0
        width: 100%
        height: 100%
    }
}
</style>